// extracted by mini-css-extract-plugin
export var categoryContainer = "KLi4q";
export var categoryMaxWidth = "FnIbR";
export var categoryMaxWidthWithButton = "Jj7qT";
export var categoryName = "KwNwl";
export var categoryNameFullDensity = "c4OEh";
export var lastCategoryContainer = "sMvzY";
export var removeCategoryButton = "EfOrL";
export var sparkleIcon = "hLH_C";
export var sparkleIconLast = "BZcPZ";